import React from "react";

const ActionButtonsSection = ({
  filtersLoading,
  selectedOutlets,
  CashPositionSectionComponent,
  TopicsHierarchyModalComponent,
}) => {
  return (
    <div className="flex flex-col items-end justify-end gap-3">
      {/* Cash Position Button */}
      {!filtersLoading && selectedOutlets.length > 0 && (
        <CashPositionSectionComponent />
      )}

      {/* Topics Hierarchy Modal Button */}
      {!filtersLoading && <TopicsHierarchyModalComponent />}
    </div>
  );
};

export default ActionButtonsSection;
